import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
        <p className="footer_text t-grey">
            © 2024 EdaFace NFT. All Rights Reserved.
        </p>
    </footer>
  )
}

export default Footer;